export default __webpack_public_path__ + "static/media/bagarre.d3259307.png";